<kendo-card *ngFor="let dataItem of content; let i = index" style="width:100%;  padding: 0; margin: 0;">
    <div class="k-d-flex justify-content-space-between k-align-items-start item"
        [ngClass]="{'unread': dataItem?.actions === 5 || dataItem?.actions === notificationAction.Created}"
        style="width:100%">
        <!-- Mark as read button -->
        <!-- TODO: need to change this to use the font awesome icon instead -->
        <button kendoButton [svgIcon]="circle" id="mark-btn"
            [themeColor]="(dataItem?.actions === 5 || dataItem?.actions === notificationAction.Created) ? 'primary': 'light'"
            fillMode="flat" size="small" (click)="mark(dataItem)" kendoTooltip
            [title]="dataItem.type === notificationType.ActionRequired ? 'Mark as done' : 'Mark as Read'"
            [attr.aria-label]="getMarkButtonAriaLabel(dataItem, i)"
            position="bottom"
            [ngClass]="{'k-pointer-events-none': (dataItem?.actions !== 5 && dataItem?.actions !== notificationAction.Created)}"></button>
        <div class="message" style="flex:1">
            <span>{{dataItem.message}}</span>
            <div><small>{{dataItem?.dateTime}}</small></div>
        </div>
        <button kendoButton fillMode="flat" themeColor="primary" (click)="mark(dataItem, true)"
            [attr.aria-label]="getViewButtonAriaLabel(dataItem, i)"
            *ngIf="showViewButton(dataItem)">View</button>
    </div>
</kendo-card>
<div *ngIf="content.length === 0" class="no-notifications">
    <p class="k-mb-0 k-px-5"><strong>No notifications to display.</strong></p>
    <p class="k-px-5 k-mt-0">We’ll notify you when there’s something new. To view past notifications, click “View All.”</p>
</div>

<!---Schedule Meeting Dialog---->
<app-schedule-meeting [nycIds]="dataNycId" *ngIf="showScheduleMeetingDialog$ | async"
    (close)="showScheduleMeetingDialog$.next(false)" [meetingType]="meetingTypeENUM.IEP" [referralSk]="referralSk"
    [caseStage]="caseStage" [meetingRoster]="meetingRoster" [actionText]="iepMeetingActionText"></app-schedule-meeting>